export default [
    {
        path: '/phone-sms',
        props: true,
        component: () => import('@/views/PhoneSms'),
    },
];